import { render } from "./NotificationEmail.vue?vue&type=template&id=3af37db4&scoped=true"
import script from "./NotificationEmail.vue?vue&type=script&lang=js"
export * from "./NotificationEmail.vue?vue&type=script&lang=js"

import "./NotificationEmail.vue?vue&type=style&index=0&id=3af37db4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af37db4"]])

export default __exports__